import React from "react";
import Modal from "./Modal";
import { Input } from "components/forms/Input";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Button from "components/forms/Button";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const ModalCodesCreateAmount = ({
  setAmount,
  nextAction,
  close,
}: {
  setAmount: (amount: number) => void;
  nextAction: () => void;
  close: () => void;
}) => {
  const handleCreate = (amount: number) => {
    setAmount(amount);
    nextAction();
  };

  return (
    <Modal width={500} close={close}>
      <h1 className="text-center text-2xl font-bold px-10">
        Hoeveel personen ga je maximaal fotograferen?
      </h1>
      <p className="text-gray-500 text-sm text-center">
        Kies voor de zekerheid een iets hoger aantal
      </p>

      <Formik
        initialValues={{ amount: 1 }}
        validationSchema={Yup.object({
          amount: Yup.number()
            .min(1, "Vul een aantal in")
            .max(10000, "Aantal mag maximaal 10000 zijn")
            .required("Vereist"),
        })}
        onSubmit={(values) => handleCreate(values.amount)}
      >
        <Form>
          <div className="flex flex-col gap-4 mt-8">
            <Input
              type="number"
              name="amount"
              centered={true}
              className="max-w-[150px]"
            />
            <Button type="submit" className="self-end">
              Volgende <FaArrowRight />
            </Button>
          </div>
        </Form>
      </Formik>
    </Modal>
  );
};

export default ModalCodesCreateAmount;
